<template>
  <v-card>
    <template v-if="fund.precheck">
      <v-card-title>
        {{ $t("reportSummary.precheck") }}
      </v-card-title>

      <v-card-text>
        {{ fund.report.fundResult.minimalRequirementsText }}
      </v-card-text>
    </template>

    <template v-if="!fund.precheck">
      <v-card-title>
        {{ $t("reportSummary.minimal") }}
      </v-card-title>

      <v-card-text v-if="fund.report.minimalRequirementsResult === 'PASS'">
        {{ $t("fund.report.minimalRequirementsPassed") }}
      </v-card-text>

      <v-card-text v-if="fund.report.minimalRequirementsResult === 'FAIL'">
        <Markdown :value="fund.report.fundResult.minimalRequirementsText" />
      </v-card-text>
    </template>

    <template v-if="fund.report.categoriesWithStars">
      <v-card-title>
        {{ $t("reportSummary.step") }}
      </v-card-title>

      <v-card-text>
        <Markdown :value="fund.report.fundResult.stepModelRequirementsText" />
      </v-card-text>

      <StepModelRequirementsSummaryTable :fund="fund" :audit="audit" />
    </template>
  </v-card>
</template>

<script>
import StepModelRequirementsSummaryTable from "@/components/User/Fund/Report/StepModelRequirementsSummaryTable.vue";

export default {
  components: {
    StepModelRequirementsSummaryTable,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
